import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faSave } from "@fortawesome/pro-solid-svg-icons"
import { Box } from "@mui/material"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useApi } from "auth/useApi3"
import ClpButton from "components/Button"
import IconForButton from "components/ButtonIcon"
import { Formik } from "formik"
import { apiEndpoints } from "generated/apiEndpoints"
import { IDeviationProps } from "pages/deviation/deviation.interface"
import {
  ActionsTextField,
  AssignDropdown,
  AttachmentArea,
  NotesTextField,
  PriorityDropdown,
  ReportedCheckbox,
  StatusDropdown
} from "pages/deviation/pages/components/DeviationComponents"
import { useTranslation } from "react-i18next"
import FormUserPicker from "components/Form/FormComponents/FormUserPicker/FormUserPicker"
import { BasicUser } from "components/Form/FormComponents/FormUserPicker/FormUserPicker.interfaces"

const EditDeviationForm = (props: IDeviationProps) => {
  const { id } = props
  const [deviationResult, postForm] = useApi() as [IApiResult, IApiFunc]
  const { t } = useTranslation("translation")

  const validate = (values: any) => {
    const errors: any = {}
    const validUser = parseInt(values.involvedUserId)
    if (isNaN(validUser)) {
      errors.involvedUserId = t("deviation.pick_user", "Pick a user")
    }
    return errors
  }

  const handleSubmit = async (values: any) => {
    const postValues = {
      ...values,
      id: id,
      assignedUserId: values.assignedUserId
    }
    postForm.put(apiEndpoints.deviation.updatedeviation, postValues)
  }

  const statusOptions: Array<{ label: string; value: number }> = [
    { label: t("global.new", "New"), value: 0 },
    { label: t("global.assigned", "Assigned"), value: 1 },
    { label: t("global.ongoing", "Ongoing"), value: 4 },
    { label: t("global.completed", "Completed"), value: 2 }
  ]

  const priorityOptions: Array<{ label: string; value: number }> = [
    { label: t("global.none", "None"), value: 0 },
    { label: t("global.low", "Low"), value: 1 },
    { label: t("global.medium", "Medium"), value: 2 },
    { label: t("global.high", "High"), value: 3 }
  ]

  return (
    <>
      <Formik initialValues={props} onSubmit={(values) => handleSubmit(values)} enableReinitialize={true} validate={validate}>
        {(formikProps) => {
          const { handleSubmit } = formikProps
          const initialUser: BasicUser = {
            id: formikProps.values.involvedUserId,
            name: "Involved user",
            username: "Involved user",
          }

          return (
            <Box>
              <form id="DeviationForm" onSubmit={handleSubmit} noValidate>
                <>
                  <Box mb={2}>
                    <FormUserPicker
                      id="involvedUserId"
                      labelKey="global.driver"
                      labelDefault="Driver"
                      handleChange={(_, userId) => {
                        formikProps.setFieldValue("involvedUserId", parseInt(userId))
                      }}
                      options={[]}
                      value={initialUser || null}
                      optional={false}
                      helperText={formikProps.errors.involvedUserId}
                    />
                  </Box>
                  <Box mb={2}>
                    <StatusDropdown id={id} statusOptions={statusOptions} />
                  </Box>
                  <Box mb={2}>
                    <PriorityDropdown id={id} priorityOptions={priorityOptions} />
                  </Box>
                  <Box mb={2}>
                    <AssignDropdown props={props} />
                  </Box>
                  <Box mb={2}>
                    <ActionsTextField />
                  </Box>
                  <Box mb={2}>
                    <NotesTextField />
                  </Box>
                  <Box mb={2}>
                    <ReportedCheckbox />
                  </Box>
                  <ClpButton
                    type="submit"
                    color="primary"
                    variant="contained"
                    result={deviationResult}
                    startIcon={<IconForButton icon={faSave as IconProp} color="primary" />}>
                    {t("global.buttons.save", "Save")}
                  </ClpButton>
                </>
              </form>
            </Box>
          )
        }}
      </Formik>
      <Box mt={2}>
        <AttachmentArea id={id} />
      </Box>
    </>
  )
}

export default EditDeviationForm
